import { api } from "@api/api";
import { TiledeskStatus } from "@modules/tiledesk/types";

export interface CreateTiledeskAgentsInput {
  agreementId: string;
  emails: string[];
}

export async function createTiledeskAgentsService({
  agreementId,
  emails,
}: CreateTiledeskAgentsInput): Promise<TiledeskStatus> {
  const { data } = await api.post<TiledeskStatus>(
    `v1/tiledesk/agreements/${agreementId}/agents/`,
    { emails }
  );
  return data;
}
